import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";
import cn from "mcn";

export const Input = forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, onFocus, ...props }, ref) => {
    return (
      <input
        ref={ref}
        onFocus={(e) => {
          e.target.select();
          onFocus?.(e);
        }}
        {...props}
        className={twMerge(
          cn(
            "px-3 py-1.5 border border-outline rounded-lg bg-surface-1 text-foreground",
            "hover:border-outline-hover",
            "focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary",
            "disabled:bg-[var(--colour-surface-disabled,#F0F0F0)] disabled:border-[var(--colour-surface-disabled,#F0F0F0)] disabled:text-[var(--colour-text-on-disabled,#A3A3A3)] disabled:cursor-not-allowed",
            "placeholder:text-foreground-muted",
          ),
          className,
        )}
      />
    );
  },
);

Input.displayName = "Input";
